// solution store

export default {
  namespaced: true,
  state: {
    nextPageSolution: null,
    lastSolution: null,
    sectionIndex: null,
    solutionCount: 0
  },
  mutations: {
    setNextPageSolution(state, solution) {
      state.nextPageSolution = solution;
    },
    setLastSolution(state, solution) {
      state.lastSolution = solution;
    },
    setSectionIndex(state, index) {
      state.sectionIndex = index;
    },
    setSolutionCount(state, count) {
      state.solutionCount = count;
    },
    incrementSolutionCount(state) {
      state.solutionCount++;
    }
  }
};
